import assetsManager from "../assets/assetsmanager/assestsmanager";
import React, { useState } from "react";

const AlertModal = ({ alertMessage, handleNo, handleYes }) => {
  //loading state to disable events
  const [loading, setLoading] = useState(false);

  return (
    <div className="alertModal flex items-center justify-center h-full w-screen absolute inset-0 bg-[grey] z-[1] bg-opacity-50">
      <div className="modal bg-white rounded-md p-6  px-9 relative">
        <div className="modal-body flex items-center justify-center flex-col">
          <img className="mb-4" src={assetsManager.alertIcon} alt="" />
          <h4 className="text-xl font-bold">Alert!</h4>
          <p className="text-[#676767] text-[15px] max-w-[21rem] text-center">
            {alertMessage}
          </p>
          <div className="flex gap-4 w-fit mt-3">
            <button
              onClick={handleNo}
              className="border-[#D1D1D1] border-[2px] text-sm p-1 rounded-[4px] w-[5rem] disabled:cursor-not-allowed"
              disabled={loading}
            >
              No
            </button>
            <button
              onClick={async () => {
                setLoading(true);
                await handleYes();
                setLoading(false);
              }}
              className="text-sm bg-[#C7222A] border-[#C7222A] border-[2px] text-white p-1 rounded-[4px] w-[5rem] disabled:cursor-not-allowed"
              disabled={loading}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
